<script>
  export let gradientTextStyle;
  const arrFSizes = [96, 72, 64, 48, 32, 24, 16, 14, 12, 10];
</script>

<div class="gradient-text-container">
  <div>
    {#each arrFSizes as fs}
      <span>Font Size : {fs}</span>
      <h1 style="{gradientTextStyle} font-size:{fs}px">SAMPLE</h1>
    {/each}
  </div>
  <p class="text-of-gradient-style">{gradientTextStyle}</p>
  <button
    class="edit-button"
    on:click={() => {
      const cb = navigator.clipboard;
      cb.writeText(gradientTextStyle).then(() => alert("Style copied"));
    }}>Copy Style</button
  >
</div>

<style>
  .gradient-text-container {
    display: flex;
    flex-direction: column;
    width: 520px;
    /* height: 240px; */
    border: 1px solid gray;
    margin: 0;
  }
  /* gradient-text-container > div {
    display: flex;
    flex-direction: row;
  } */
  span {
    float: right;
    margin-right: 32px;
    font-size: 9px;
    font-style: italic;
    border: 1px solid #999;
    border-radius: 12px;
    padding: 2px;
  }
  .text-of-gradient-style {
    font-size: 12px;
    border-top: 3px ridge rgb(165, 161, 161);
    padding: 5px;
    margin: 0;
    color: #fff;
    background-color: #000;
  }

  h1 {
    /* font-size: 96px; */
    text-align: center;
    /* width: 100%; */
    /* height: 100%; */
    /* border: 1px dotted blue; */
    padding-top: 6px;
    margin: 6px;
    letter-spacing: 6px;
    /* margin-left: 60px; */
  }
</style>
